// extracted by mini-css-extract-plugin
module.exports = {"Dialog":"dialog_Dialog__x2BHX","closeBtn":"dialog_closeBtn__lJASy"};